/**
 * Senior-level authentication validation utility
 */

export const authValidation = {
  /**
   * Validates email format and domain
   */
  validateEmail: (email) => {
    if (!email) return "Email is required";
    const emailRegex = /^[^\s@]+@[^\s@]+\.(com|in|org|net)$/i;
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address (e.g. .com, .in)";
    }
    return "";
  },

  /**
   * Validates mobile number (10 digits)
   */
  validateMobile: (mobile) => {
    if (!mobile) return "Mobile number is required";
    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(mobile)) {
      return "Mobile number must be exactly 10 digits";
    }
    return "";
  },

  /**
   * Validates password complexity
   */
  validatePassword: (password) => {
    if (!password) return "Password is required";
    if (password.length < 8) {
      return "Password must be at least 8 characters long";
    }
    if (!/[A-Z]/.test(password)) {
      return "Include at least one uppercase letter";
    }
    if (!/[a-z]/.test(password)) {
      return "Include at least one lowercase letter";
    }
    if (!/[0-9]/.test(password)) {
      return "Include at least one number";
    }
    if (!/[\W_]/.test(password)) {
      return "Include at least one special character";
    }
    return "";
  },

  /**
   * Validates full name
   */
  validateFullName: (name) => {
    if (!name) return "Full name is required";
    if (name.trim().length < 3) {
      return "Name must be at least 3 characters long";
    }
    if (!/^[a-zA-Z\s]+$/.test(name)) {
      return "Name should only contain letters and spaces";
    }
    return "";
  },

  /**
   * Calculates password strength (0-4)
   */
  getPasswordStrength: (password) => {
    if (!password) return 0;
    
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[\W_]/.test(password)) strength++;
    return strength;
  }
};
